import axios from "@/plugins/axios";
import { getApiUrl } from "@/services/_apiUrl";

const apiUrl = getApiUrl();

export function fetchIntegrations() {
  return axios.get(apiUrl.integrations.GET.LIST);
}

export function disconnectIntegration(key) {
  return axios.delete(`${apiUrl.integrationDisconnect.DELETE}${encodeURIComponent(key)}/`);
}

export function connectIntegration(key) {
  return axios.get(`${apiUrl.integrationConnect.GET}${encodeURIComponent(key)}/`);
}
